// extracted by mini-css-extract-plugin
module.exports = {"CaptionCell":"CaptionCell_CaptionCell__Z71FC"};